import React, { useState } from 'react';
import {
  IconButton,
  SimpleGrid,
  Button,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { ViewIcon } from '@chakra-ui/icons';
import { getData } from '../../utils/httpClient';
import AppointmentEntityDrawer, { DetailItem } from './AppointmentEntityDrawer';

const AppointmentVehicleDetailButton = ({ selectedVehicle, selectedCustomer }) => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [vehicleDetail, setVehicleDetail] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const openDetail = async () => {
    if (!selectedVehicle?.id) return;
    setLoading(true);
    setVehicleDetail(null);
    onOpen();
    try {
      const response = await getData(`/vehicles/${selectedVehicle.id}`);
      const vehicle = response?.payload?.vehicle;
      if (!vehicle) throw new Error('Sin datos');
      setVehicleDetail(vehicle);
    } catch {
      onClose();
      toast({
        title: 'Error',
        description: 'No se pudo cargar el detalle del vehículo.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const modelLabel =
    vehicleDetail?.model?.description ||
    (typeof vehicleDetail?.model === 'string' ? vehicleDetail.model : null);

  const brandLabel =
    vehicleDetail?.model?.brand?.name || vehicleDetail?.brand || '—';

  return (
    <>
      <IconButton
        size="sm"
        aria-label="Detalle del vehículo"
        icon={<ViewIcon />}
        variant="ghost"
        colorScheme="gray"
        onClick={openDetail}
        isLoading={loading}
        isDisabled={!selectedVehicle?.id}
      />

      <AppointmentEntityDrawer
        isOpen={isOpen}
        onClose={onClose}
        title="Detalle del vehículo"
        loading={loading}
        footer={
          <Button w="100%" onClick={onClose}>
            Cerrar
          </Button>
        }
      >
        {vehicleDetail && (
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            <DetailItem label="Patente" value={vehicleDetail.plate} />
            <DetailItem label="Marca" value={brandLabel} />
            <DetailItem label="Modelo" value={modelLabel} />
            <DetailItem label="Año" value={vehicleDetail.year} />
            <DetailItem label="Chasis" value={vehicleDetail.chassisNumber} />
            <DetailItem label="Motor" value={vehicleDetail.engineNumber} />
            <DetailItem label="Color" value={vehicleDetail.color?.name} />
            <DetailItem label="Combustible" value={vehicleDetail.fuelType?.type} />
            <DetailItem label="Kilometraje anterior" value={vehicleDetail.kilometers} />
            <DetailItem
              label="Dueño actual"
              value={
                vehicleDetail.currentCustomer?.name || selectedCustomer?.name
              }
            />
            <DetailItem
              label="Documento dueño"
              value={vehicleDetail.currentCustomer?.document}
            />
            <DetailItem
              label="Teléfono dueño"
              value={vehicleDetail.currentCustomer?.phone}
            />
          </SimpleGrid>
        )}
      </AppointmentEntityDrawer>
    </>
  );
};

export default AppointmentVehicleDetailButton;
